module.exports = __webpack_public_path__ + "img/dianwang.2fe852f8.png";